module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_13.94b68c37.png";